define('plugin/paid-attributes/PaidAttributesPlugin',['require','plugin/product/ProductPlugin','plugin/paid-attributes/view/AttributeListView','plugin/paid-attributes/step/PaidAttributesStep','plugin/product/collection/ProductCollection'],function (require) {

    var ProductPlugin = require('plugin/product/ProductPlugin');
    var AttributeListView = require('plugin/paid-attributes/view/AttributeListView');
    var PaidAttributesStep = require('plugin/paid-attributes/step/PaidAttributesStep');
    var ProductCollection = require('plugin/product/collection/ProductCollection');

    return ProductPlugin.extend({

        _productRegions: {
            attribute: '#sb_attribute_container'
        },
        _productModuleRegions: {
            // nothing
        },

        _onPage: 10,
        _type: 'attribute',

        _supportsCart: false,
        
        _isTimelineSupportingStep: function () {
            var unSupportedTimelines = [Config.TIMELINE_CLASSES, Config.TIMELINE_CLASSES_PLUGIN, Config.TIMELINE_GRID_WEEKLY];
            
            return !_.contains(unSupportedTimelines, Config.getInstance().getTimelineType());
        },
        
        initStepManagerEvents: function () {
            this._bookingModel = this._stepManager.getBookingModel();

            if (this._isTimelineSupportingStep()) {
                this.listenTo(this._bookingModel, 'change:service_id', this._loadCollection);
                this.listenTo(this._stepManager, 'step:fetch_done:service', this._onDataFetchServiceStep);
            } else {
                this.listenTo(this._stepManager, 'step:render:details', this.beforeDetailsShow);
                this.listenTo(this._bookingModel, 'change:service_id', this._resetCollection);
            }
        },
        
        /**
         * Return plugin list view
         *
         * @param collection
         * @return {*}
         */
        _getListView: function (collection) {
            var view = new AttributeListView({
                bookingModel: this._bookingModel,
                collection: collection
            });

            view.setPage(this._page);
            view.setOnPage(this._onPage);

            this.listenTo(view, 'page:changed', this.triggerPageShown);

            return view;
        },

        /**
         * Display list view in proper region
         *
         * @return Region
         */
        _getListRegion: function () {
            return this._detailsStepView.attribute;
        },
        
        /**
		 * Adds paid_attributes step
		 * 
		 * @param Array steps
		 * @return Array|null
		 */
		modifySteps: function (steps) {
            if (this._isTimelineSupportingStep()) {
                steps.splice(steps.indexOf('service') + 1, 0, 'paid_attributes');
            }
			return steps;
		},
        
        /**
		 * Returns plugin step object
		 * 
		 * @see lib/controller/booking/BaseStep
		 * @param String step - step name
		 * @param Object params - step parameters
		 * @return BaseStep|null
		 */
		getStep: function (step, params) {
            if (this._isTimelineSupportingStep()) {
                if (step === 'paid_attributes') {
                    return new PaidAttributesStep(_.extend({
                        collection: this._getCollection()
                    }, params));
                }
            }
		},
        
        beforeDetailsShow: function (step, view, region) {
            if (!this._isTimelineSupportingStep()) {
                return ProductPlugin.prototype.beforeDetailsShow.apply(this, arguments);
            }
        },

        /**
         * After save booking
         *
         * @param Object data
         */
        afterSaveBooking: function (data) {
            if (!data.get('confirm')) {
                this._loadCollection();
            }

            return ProductPlugin.prototype.afterSaveBooking.apply(this, arguments);
        },

        /**
         * Instantiate product collection in case it is null
         *
         * @private
         * @return ProductCollection
         */
        _getCollection: function () {
            if (this._isTimelineSupportingStep()) {
                if (!this._collection) {
                    this._collection = new ProductCollection();
                    
                    this.listenTo(this._collection, 'change', this.updateProducts);
                    this.listenTo(this._collection, 'sync', this.updateProducts);
                }
                
                return this._collection;
            } else {
                return ProductPlugin.prototype._getCollection.apply(this, arguments);
            }
        },
        
        _loadCollection: function () {
            this._getCollection().reload({
                data: {
                    'service_id': this._bookingModel.get('service_id') || -1, // -1 to prevent loading full list of attributes
                    'type': this._type
                }
            });
        },
        
        _resetCollection: function () {
            if (this._isTimelineSupportingStep()) {
                this._getCollection().reset();
            } else {
                return ProductPlugin.prototype._resetCollection.apply(this, arguments);
            }
        },

        /**
         * Adds filter to services collection
         *
         * @param data
         */
        _onDataFetchServiceStep: function (data) {
            var isHideStep = true;

            data.forEach(function (service) {
                if (service.has_paid_attributes) {
                    isHideStep = false;
                    return false;
                }
            }, this);

            if (isHideStep) {
                this._stepManager._skipSteps(['paid_attributes']);
                this._stepManager.hideStep('paid_attributes');
            }
        },

    });

});
